import JoinRoom from '@/components/Student/JoinRoom'

const JoinRoomScreen = () => {
  return <JoinRoom />
}

export default JoinRoomScreen
